<template>
    <div class="pp-cell__wrap" @click="click">
        <div v-if="$slots.prefix" ref="prefix" class="pp-cell__prefix">
            <slot name="prefix"></slot>
        </div>
        <div ref="content" class="pp-cell">
            <div class="pp-cell__content">
                <div class="pp-cell__title">
                    <slot>{{title}}</slot>
                </div>
                <p v-if="label != null" class="pp-cell__label" v-html="label"></p>
            </div>
        </div>
        <div v-if="$slots.suffix || value || currentWithMore" class="pp-cell__suffix">
            <div ref="suffix" class="pp-cell__value">
                <slot name="suffix">
                    {{value}}
                </slot>
            </div>
            <i v-if="currentWithMore" class="pp-cell__with-more pp-icon-arrow-right"></i>
        </div>
    </div>
</template>

<script>
/**
 * 单元格
 * @desc 后期开放link功能
 * @param {boolean} withMore 带右侧箭头图标
 * @param {string} title 标题 
 * @param {string} value 后缀 
 * @param {string} label 标签
 * 
 * @event click 点击
 */
export default {
    name: 'pp-cell',
    inject: {
        CellGroup: {
            default: '',
        },
    },
    props: {
        withMore: Boolean,
        title: String,
        value: [String, Number, Boolean],
        label: String,
    },
    computed: {
        currentWithMore: function() {
            return this.withMore || this.CellGroup.withMore;
        },
    },
    methods: {
        click: function(e) {
            this.$emit('click', e)
        },
    },
}
</script>
